<template>
  <div class="inquiry_bg" v-show="dialogVisible">
    <div class="inquiry_box">
      <div class="inquiry_box_header">
        <div class="inquiry_box_title">Relationship Inquiry</div>
        <i class="iconfont icon-cuowu" @click="closeDialog"></i>
      </div>
      <div class="inquiry_list">
        <div class="inquiry_list_label">Target Company:</div>
        <div class="inquiry_list_content">
          {{ name || "-" }}
        </div>
      </div>
      <div class="inquiry_list">
        <div class="inquiry_list_label">Queried company:</div>
        <div class="inquiry_list_content">
          <el-input
            v-model="filterName"
            placeholder="Enter company name"
            allowClear
          ></el-input>
        </div>
      </div>
      <div class="inquiry_box_content">
        <div class="empty" v-if="filterName == ''">
          No results found yet, please select the queried company
        </div>
        <div v-else-if="type == '1'" class="tab_content">
          <div class="tab_header">
            <div
              class="tab_header_item"
              :class="{ active: activeTab == tabItem.id }"
              v-for="tabItem in TabList"
              :key="tabItem.id"
              @click.stop="activeTab = tabItem.id"
            >
              {{ tabItem.name }}
            </div>
          </div>
          <div class="tab_content_box">
            <template v-if="activeTab == 1">
              <div class="content_list">
                <div class="content_list_label">Suspected Suppliers:</div>
                <div class="content_list_content">BLACKROCK, INC</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Recent trade date:</div>
                <div class="content_list_content">2025-12</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Industry code:</div>
                <div class="content_list_content">2620</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Trade Related Companies:</div>
                <div class="content_list_content">In cooperation</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Trade Related Product:</div>
                <div class="content_list_content"></div>
              </div>
              <el-table
                class="risk_table"
                :data="tableData"
                height="100%"
                ref="tableRef"
                :row-key="(row) => row.aaaId"
              >
                <el-table-column
                  prop="product"
                  align="center"
                  label="Product Name"
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="volume"
                  align="center"
                  label="Volume"
                  min-width="110"
                >
                </el-table-column>
              </el-table>
            </template>
            <template v-else>
              <div class="content_list">
                <div class="content_list_label">Holding company:</div>
                <div class="content_list_content">BLACKROCK, INC</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Controlled company:</div>
                <div class="content_list_content">Apple Inc.</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Owner Hierarchy Level:</div>
                <div class="content_list_content">3</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">
                  Direct Ownership Percentage:
                </div>
                <div class="content_list_content">15%</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">
                  Total Ownership Percentage:
                </div>
                <div class="content_list_content">4%</div>
              </div>
              <div class="content_list">
                <div class="content_list_label">Ultimate Beneficial Owner:</div>
                <div class="content_list_content">BLACKROCK, INC</div>
              </div>
            </template>
          </div>
        </div>
        <div class="list_content" v-else-if="type == '2'">
          <div class="list_content_title">Query Result</div>
          <div class="content_list">
            <div class="content_list_label">Holding company:</div>
            <div class="content_list_content">BLACKROCK, INC</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Controlled company:</div>
            <div class="content_list_content">Apple Inc.</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Owner Hierarchy Level:</div>
            <div class="content_list_content">3</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Direct Ownership Percentage:</div>
            <div class="content_list_content">15%</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Total Ownership Percentage:</div>
            <div class="content_list_content">4%</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Ultimate Beneficial Owner:</div>
            <div class="content_list_content">BLACKROCK, INC</div>
          </div>
        </div>
        <div class="list_content" v-else-if="type == '3'">
          <div class="list_content_title">Query Result</div>
          <div class="content_list">
            <div class="content_list_label">Holding company:</div>
            <div class="content_list_content">BLACKROCK, INC</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Controlled company:</div>
            <div class="content_list_content">Apple Inc.</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Investment Hierarchy Level:</div>
            <div class="content_list_content">3</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Direct Control Percentage:</div>
            <div class="content_list_content">15%</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Total Control Percentage:</div>
            <div class="content_list_content">4%</div>
          </div>
        </div>
        <div class="list_content" v-else-if="type == '4'">
          <div class="list_content_title">Query Result</div>
          <div class="content_list">
            <div class="content_list_label">Parent company:</div>
            <div class="content_list_content">BLACKROCK, INC</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Subsidiary company:</div>
            <div class="content_list_content">Apple Inc.</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Associated type:</div>
            <div class="content_list_content">Equity control bank</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Relationship:</div>
            <div class="content_list_content">Equity related</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Related years:</div>
            <div class="content_list_content">4</div>
          </div>
        </div>
        <div class="list_content" v-else-if="type == '6'">
          <div class="list_content_title">Query Result</div>
          <div class="content_list">
            <div class="content_list_label">Parent company:</div>
            <div class="content_list_content">BLACKROCK, INC</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Subsidiary company:</div>
            <div class="content_list_content">Apple Inc.</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Associated type:</div>
            <div class="content_list_content">Equity control bank</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Relationship:</div>
            <div class="content_list_content">Equity related</div>
          </div>
          <div class="content_list">
            <div class="content_list_label">Related years:</div>
            <div class="content_list_content">4</div>
          </div>
          <el-table
            class="risk_table"
            :data="tableData"
            height="100%"
            ref="tableRef"
            :row-key="(row) => row.aaaId"
          >
            <el-table-column
              prop="product"
              align="center"
              label="Product Name"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="volume"
              align="center"
              label="Volume"
              min-width="110"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Inquiry",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: "1", //1.Background 2.Ownership 3.Investments 4.RelatedCompanies 5.Management 6.SupplyChain 7.UboRuler 8.InquiryDialog
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterName: "",
      activeTab: 1,
      TabList: [
        { id: 1, name: "Holding" },
        { id: 2, name: "Controlled by" },
        { id: 3, name: "Suspected Suppliers" },
        { id: 4, name: "Suspected Buyers" },
      ],
      tableData: [
        {
          product:
            "Indicator panels incorporating liqu id crystal devices (LCD)",
          volume: "119",
        },
        {
          product: "Dried Apples",
          volume: "122",
        },
        {
          product: "Lithium cells and batteries",
          volume: "122",
        },
        {
          product: "Smartphones",
          volume: "122",
        },
      ],
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style scoped>
.inquiry_bg {
  width: 100%;
  height: 100%;
  z-index: 9;
  position: absolute;
  right: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.9);
}
.inquiry_box {
  width: 660px;
  height: 100%;
  float: right;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 30px 20px;
  overflow: auto;
}
.inquiry_box_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.inquiry_box_title {
  font-size: 24px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}
.inquiry_box_header i {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}
.inquiry_list {
  height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 30px;
}
.inquiry_list_label {
  font-size: 18px;
  color: #666666;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}
.inquiry_list_content {
  flex: 1;
  font-size: 18px;
  color: #1a2332;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}
.inquiry_list_content >>> .el-input__inner {
  height: 40px;
}
.inquiry_box_content {
  width: 100%;
  height: auto;
  margin-top: 30px;
}
.empty {
  width: 100%;
  height: 360px;
  background: #f5f5f5;
  border-radius: 6px;
  padding-top: 140px;
  font-size: 18px;
  color: #999999;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}
.list_content {
  width: 100%;
  height: auto;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 20px;
}
.list_content_title {
  height: 30px;
  font-size: 24px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}

.content_list {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.content_list_label {
  font-size: 18px;
  color: #666666;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  width: 242px;
}
.content_list_content {
  flex: 1;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.tab_content {
}
.tab_header {
  display: flex;
  justify-content: space-between;
}
.tab_header_item {
  width: auto;
  padding: 13px;
  height: 50px;
  background: #f5f5f5;
  border-radius: 6px 6px 0px 0px;
  font-size: 18px;
  color: #999999;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}
.tab_header_item.active {
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(153, 153, 153, 0.5);
  color: #1a2332;
}
.tab_content_box {
  width: 100%;
  height: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(153, 153, 153, 0.5);
}
@media (max-width: 1920px) {
  .inquiry_box {
    width: 560px;
    padding: 24px 16px;
  }
  .inquiry_box_title {
    font-size: 20px;
    line-height: 24px;
  }
  .inquiry_box_header i {
    width: 16px;
    height: 16px;
    font-size: 16px;
  }
  .inquiry_list {
    height: 30px;
    gap: 8px;
    margin-top: 24px;
  }
  .inquiry_list_label {
    font-size: 16px;
    line-height: 30px;
  }
  .inquiry_list_content {
    font-size: 16px;
    line-height: 30px;
  }
  .inquiry_list_content >>> .el-input__inner {
    height: 30px;
  }
  .inquiry_box_content {
    margin-top: 24px;
  }
  .empty {
    height: 280px;
    padding-top: 110px;
    font-size: 16px;
    line-height: 16px;
  }
  .list_content {
    padding: 16px;
  }
  .list_content_title {
    height: 24px;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 16px;
  }

  .content_list {
    height: 20px;
    gap: 8px;
    margin-bottom: 16px;
  }
  .content_list_label {
    font-size: 16px;
    line-height: 20px;
    width: 200px;
  }
  .content_list_content {
    font-size: 16px;
    line-height: 20px;
  }
  .tab_header_item {
    padding: 10px;
    height: 38px;
    font-size: 16px;
  }

  .tab_content_box {
    padding: 16px;
  }
}
</style>
